import { reportStrategyError } from 'src/utils/rollbar';
import registrationFlowStrategy from './strategies/registrationFlowStrategy';

function getStrategy(flow) {
  switch (flow.strategyType) {
    case 'registration':
      return registrationFlowStrategy;
    default:
      return () => {
        reportStrategyError(flow);
        throw new Error(`Invalid strategyType "${flow.strategyType}" for flow "${flow.id}"`);
      };
  }
}

export default {
  initialize: function(config = {}, flow = {}) {
    getStrategy(flow)(config, flow);
  }
};
